module.exports = __webpack_public_path__ + "static/media/time.00c7dc43.svg";